export default "__VITE_ASSET__BuYqY9vi__"